import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

export enum MetaAdsCampaignStatus {
  APPROVED = 'approved',
  ENDED = 'ended',
  RUNNING = 'running',
  SCHEDULED = 'scheduled',
}

export enum MetaAdsStrategy {
  TRACK = 'track',
  PLAYLIST = 'playlist',
}

export type MetaAdsCampaignDetails = {
  countries?: string[]
  genres?: string[]
  languages?: string[]
  similarArtistNames?: string[]
  id?: number
  countriesTier?: null | string
  coverUrl?: string
  createdAt?: string
  endDate?: string
  landingKey?: string
  landingUrl?: string
  ownerName?: string
  ownerSpotifyUrl?: string
  paymentId?: null | number
  resourceName?: string
  resourceSpotifyId?: string
  resourceSpotifyUrl?: string
  startDate?: string
  status?: MetaAdsCampaignStatus
  strategy?: MetaAdsStrategy
  updatedAt?: string
  userId?: number
  totalBudget?: number
  dailyBudget?: number
  daysCount?: null | number
  shouldAutoRenew?: boolean
}

export type SetMetaAdsAutoRenewalBody = {
  campaignId: string
  shouldAutoRenew: boolean
}

const metaAdsDetailsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getMetaAdsCampaignDetails: build.query<MetaAdsCampaignDetails, string>({
      query: (campaignID) => ({
        url: `${APP.TIKTOK_SERVER}/artist/ad-campaigns/${campaignID}`,
        method: 'GET',
      }),
      providesTags: ['MetaAdCampaign'],
    }),
    setMetaAdsAutoRenewal: build.mutation<
      MetaAdsCampaignDetails,
      SetMetaAdsAutoRenewalBody
    >({
      query: ({ campaignId, shouldAutoRenew }) => ({
        url: `${APP.TIKTOK_SERVER}/artist/ad-campaigns/${campaignId}/auto-renewal`,
        method: 'PATCH',
        body: { shouldAutoRenew },
      }),
      invalidatesTags: ['MetaAdCampaign'],
    }),
  }),
})

export const {
  useGetMetaAdsCampaignDetailsQuery,
  useSetMetaAdsAutoRenewalMutation,
} = metaAdsDetailsApi
